import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from "react-router-dom";
import { GlobalContextProvider } from "./contexts/GlobalContext";
import Login from "./components/Login";
import OnBorading from "./components/OnBorading/OnBorading";
import Dashboard from "./components/Dashboard";
import LogProgress from "./components/LogProgress";
import Quran from "./components/Quran";
import Group from "./components/Group";
import GroupDetails from "./components/GroupDetails";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/serviceWorker.js")
      .then((registration) => {
        console.log("Service Worker registered:", registration);
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* <PostHogProvider
      apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
      options={options}
    > */}
    <GlobalContextProvider>
      <Router>
        <Routes>
          {/* <Route path="/" element={<App />}></Route> */}
          <Route path="/" element={<OnBorading />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/home" element={<Dashboard />}></Route>
          <Route
            path="/new-progress/:progressId?"
            element={<LogProgress />}
          ></Route>
          <Route path="/quran" element={<Quran />}></Route>
          <Route path="/group" element={<Group />}></Route>
          <Route path="/group/:groupId" element={<GroupDetails />}></Route>
          {/* <Route path="/signup" element={<SignUp />}></Route> */}
          {/* <Route path="/sell" element={<PlaceNewAd />}></Route>
         
          
          <Route path="/my-horses" element={<MyHorses />}></Route>
          <Route path="/edit" element={<PlaceNewAd />}></Route> */}
          {/* <Route
            path="/:projectId/raise-ticket"
            element={<NewTicket />}
          ></Route> */}
          {/* <Route path="/:projectId/tickets" element={<Tickets />}></Route> */}
          {/* <Route
            path="/progress/:projectId/:ticketId"
            element={<TicketProgress />}
          ></Route> */}
          <Route path="/*" element={<Navigate to="/" />}></Route>
        </Routes>
      </Router>
    </GlobalContextProvider>
    {/* </PostHogProvider> */}
  </React.StrictMode>
);
